module.exports = __webpack_public_path__ + "96551ba604fa9701329a0d98c5bcf44f.svg";